import React, { useState } from 'react';
import { Modal, Checkbox, Radio, Upload } from 'antd';
import { Button, FormInput, FormSubmitButton, MasterDetailForm, Widget, Row, notification } from '@digital/ui';
import { UploadFile, Visibility } from '@app/components';
import { executarAcaoGestorTecnico, IAcaoGestorTecnico } from '@app/api/sas/gestorTecnico';
import ModalExibicaoArquivos from '../WidgetDocumentacao/ModalExibicaoArquivos';
import ModalComentariosParecerTecnico from '../WidgetAcompanhamentoProcesso/ComentariosParecerTecnico/ModalComentariosParecerTecnico';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { IUploadFile } from '@app/types/core.types';
import { downloadArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';

interface Props {
  visible: boolean;
  acao: IAcaoGestorTecnico;
  ordemCompraId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const ModalAcaoGestorTecnico = ({ visible, acao, ordemCompraId, onClose, onSuccess }: Props) => {
  const [decisao, setDecisao] = useState<'aprovar' | 'reprovar' | 'solicitar_revisao'>('aprovar');
  const [fileList, setFileList] = useState<IUploadFile[]>([]);

  const handleSubmit = (values: any) => {
    const executar = () => {
      const formData = new FormData();

      formData.append('ordemCompraId', ordemCompraId);
      formData.append('tipoAcao', acao.tipoAcao);
      formData.append('decisao', decisao);

      if (acao.sasPropostaId) {
        formData.append('sasPropostaId', acao.sasPropostaId);
      }

      if (acao.requisitos.requerJustificativa && values.justificativa) {
        formData.append('justificativa', values.justificativa);
      }

      if (acao.requisitos.requerMultiplosArquivos) {
        fileList.forEach((file: any) => {
          if (file.originFileObj) {
            formData.append('arquivos', file.originFileObj);
          }
        });
      } else if (acao.requisitos.requerUpload && values.arquivo) {
        formData.append('arquivo', values.arquivo);
      }

      const deveRequerArquivo = decisao === 'reprovar' || decisao === 'solicitar_revisao';

      if (acao.requisitos.requerMultiplosArquivos && deveRequerArquivo && fileList.length === 0) {
        Modal.error({
          title: 'Erro ao enviar ação',
          content: decisao == 'reprovar' ? 'É obrigatório o envio da Aprovação do Gerente Geral ao reprovar ou solicitar revisão.' : 'Upload do arquivo é obrigátorio',
        });
        return;
      }

      if (acao.requisitos.requerUpload && !acao.requisitos.requerMultiplosArquivos && deveRequerArquivo && !values.arquivo) {
        Modal.error({
          title: 'Erro ao enviar ação',
          content: decisao === 'reprovar' ? 'É obrigatório o envio da Aprovação do Gerente Geral ao reprovar.' : "É necessário anexar o arquivo com as revisões.",
        });
        return;
      }

      if (acao.requisitos.aceitarOuRecusar && decisao === 'solicitar_revisao' && !values.justificativa) {
        Modal.error({
          title: 'Erro ao enviar ação',
          content: 'A justificativa é obrigatória ao solicitar revisão.',
        });
        return;
      }

      executarAcaoGestorTecnico(formData)
        .then((response: any) => {
          if (response && response.valid) {
            onClose();
            onSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    };

      Modal.confirm({
        title: 'Confirmar ação',
        content: acao.descricaoConfirmacao,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: executar,
      });
  };

  return (
    <Modal title={acao.acao} visible={visible} width="650px" onCancel={onClose} footer={null}>
      <MasterDetailForm
        onSubmit={handleSubmit}
        actions={[
          <Button type="link" onClick={onClose}>
            Cancelar
          </Button>,
          <FormSubmitButton type="primary">Confirmar</FormSubmitButton>,
        ]}>
        <Widget>
          <Row>
            <div style={{ marginBottom: 24 }}>{acao.descricao}</div>

            {acao.parecerTecnicoRevisaoId && acao.sasPropostaId && (
              <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <ModalComentariosParecerTecnico
                  contemComentario={true}
                  id={acao.parecerTecnicoRevisaoId}
                  sasPropostaId={acao.sasPropostaId}
                  update={() => {}}
                  disabled={true}
                />
                <span style={{ fontSize: 12, color: '#8c8c8c' }}>Ver/enviar comentários ao Comprador</span>
              </div>
            )}

            {acao.requisitos.visualizarDocumento && acao.sasPropostaId && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  padding: 12,
                  backgroundColor: '#f0f2f5',
                  borderRadius: 4,
                  gap: 4
                }}>
                <ModalExibicaoArquivos
                  propostaId={acao.sasPropostaId}
                  sasTipoDocumentoId={EGuidTipoSasDocumento.PropostaTecnicaConsolidada}
                  fornecedorNome={acao.nomeFornecedor}
                  disabled={true}
                  hideExcluido={true}
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: 600 }}>Proposta Técnica - {acao.nomeFornecedor}</span>
                  <span style={{ fontSize: 12, color: '#8c8c8c' }}>Clique no ícone para visualizar os arquivos</span>
                </div>
              </div>
            )}

            {acao.requisitos.visualizarDocumento && !acao.sasPropostaId && acao.documentoRecebido && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  padding: 12,
                  backgroundColor: '#f0f2f5',
                  borderRadius: 4,
                  gap: 8
                }}>
                <Button
                  icon="ui-download"
                  onClick={() => downloadArquivo(acao.documentoRecebido!.id, acao.documentoRecebido!.arquivoNomeDownload, false)}
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: 600 }}>{acao.documentoRecebido.descricao}</span>
                  <span style={{ fontSize: 12, color: '#8c8c8c' }}>{acao.documentoRecebido.arquivoNomeDownload}</span>
                </div>
              </div>
            )}

            {acao.requisitos.aceitarOuRecusar && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>Decisão:</div>
                <Radio.Group onChange={e => setDecisao(e.target.value)} value={decisao}>
                  <Radio value="aprovar">Aprovar</Radio>
                  <Radio value="reprovar">Reprovar</Radio>
                  <Radio value="solicitar_revisao">Solicitar Revisão</Radio>
                </Radio.Group>
              </div>
            )}

            {acao.requisitos.requerJustificativa && (
              <Visibility
                visible={
                  (acao.requisitos.aceitarOuRecusar && (decisao === 'reprovar' || decisao === 'solicitar_revisao')) || !acao.requisitos.aceitarOuRecusar
                }>
                <FormInput
                  name="justificativa"
                  label={acao.requisitos.textoJustificativa || 'Justificativa'}
                  required={acao.requisitos.aceitarOuRecusar && (decisao === 'reprovar' || decisao === 'solicitar_revisao')}
                />
              </Visibility>
            )}

            {acao.requisitos.requerMultiplosArquivos && (
              <Visibility visible={!acao.requisitos.aceitarOuRecusar || decisao === 'reprovar' || decisao === 'solicitar_revisao'}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                    {decisao === 'reprovar' && acao.requisitos.textoUpload ? acao.requisitos.textoUpload : 'Adicionar Arquivos *'}
                  </label>
                  <Upload
                    multiple
                    fileList={fileList}
                    beforeUpload={(file) => {
                      const uploadFile = {
                        uid: file.uid || `${Date.now()}-${file.name}`,
                        name: file.name,
                        status: 'done' as const,
                        originFileObj: file,
                      };
                      setFileList([...fileList, uploadFile as any]);
                      return false;
                    }}
                    onRemove={(file) => {
                      setFileList(fileList.filter((f) => f.uid !== file.uid));
                    }}
                    accept=".xlsx, .xls, .png, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                  >
                    <Button type="primary" icon="ui-upload">
                      Adicionar Arquivos
                    </Button>
                  </Upload>
                </div>
              </Visibility>
            )}

            {acao.requisitos.requerUpload && !acao.requisitos.requerMultiplosArquivos && (
              <Visibility visible={!acao.requisitos.aceitarOuRecusar || decisao === 'reprovar' || decisao === 'solicitar_revisao'}>
                <div style={{ marginBottom: 20 }}>
                  <UploadFile
                    nameFormData={'arquivo'}
                    label={decisao === 'reprovar' ? acao.requisitos.textoUpload : 'Adicionar Arquivo'}
                    type="primary"
                    idDoComponente={'file-gestor-tecnico'}
                  />
                </div>
              </Visibility>
            )}

          </Row>
        </Widget>
      </MasterDetailForm>
    </Modal>
  );
};

export default ModalAcaoGestorTecnico;
